module.exports = __webpack_public_path__ + "static/3-e7b6ba4b0e524f2908719582ea743353.jpg";